module.exports = __webpack_public_path__ + "assets/img/news-7.89ac242c.jpg";